export type RiskType = "Dikkat" | "Sorunlu" | "Yasaklı" | "Etik Dışı Talep";
export type BlockedStatus = "Aktif" | "Pasif" | "İzlemede";

export interface BlockedCustomer {
  id: string;
  customerId: string;
  customerName: string;
  phone: string;
  riskType: RiskType;
  description: string;
  staffNote: string;
  lastActionDate: string;
  createdBy: string;
  status: BlockedStatus;
  createdAt: string;
  appointmentHistory: string[];
}

export const blockedCustomers: BlockedCustomer[] = [
  {
    id: "blk-001",
    customerId: "cus-012",
    customerName: "Gökhan Yılmaz",
    phone: "+90 533 333 0011",
    riskType: "Sorunlu",
    description: "Son 3 randevusuna gelmemiştir. Kaporasız randevu verilmemelidir.",
    staffNote: "Seda Avcı notu: WhatsApp teyitli randevulara da gelmedi. Randevu oluşturulmadan önce danışmadan onay alınmalı.",
    lastActionDate: "2026-04-01",
    createdBy: "Seda Avcı",
    status: "Aktif",
    createdAt: "2026-04-02",
    appointmentHistory: [
      "2026-03-25 - Gelmedi",
      "2026-03-18 - Gelmedi",
      "2026-03-10 - Gelmedi",
    ],
  },
  {
    id: "blk-002",
    customerId: "cus-013",
    customerName: "Hakan Demirtaş",
    phone: "+90 532 999 8877",
    riskType: "Etik Dışı Talep",
    description: "Personelimize uygunsuz talepte bulunmuştur. Etik dışı talep kaydı oluşturulmuştur.",
    staffNote: "Elif Y. şikayet etti: Müşteri manikür sırasında uygunsuz konuşma yaptı. Bir daha kabul edilmemeli.",
    lastActionDate: "2026-04-20",
    createdBy: "Elif Yılmaz",
    status: "Aktif",
    createdAt: "2026-04-21",
    appointmentHistory: [
      "2026-04-20 - Profesyonel Manikür - Şikayet kaydı",
    ],
  },
  {
    id: "blk-003",
    customerId: "cus-014",
    customerName: "Mine Kılıç",
    phone: "+90 535 444 1122",
    riskType: "Dikkat",
    description: "Son 2 randevusunda geç kalmış ve personel ile tartışma çıkarmıştır.",
    staffNote: "Ayşe K. notu: Müşteri 30 dk geç kaldı, randevu iptal edilecekti, tartışma çıkardı. Dikkatli olunmalı.",
    lastActionDate: "2026-05-02",
    createdBy: "Ayşe Korkmaz",
    status: "İzlemede",
    createdAt: "2026-05-03",
    appointmentHistory: [
      "2026-05-02 - 30 dk geç kaldı, tartışma",
      "2026-04-25 - 15 dk geç kaldı",
    ],
  },
  {
    id: "blk-004",
    customerId: "cus-015",
    customerName: "Serkan Ateş",
    phone: "+90 536 777 3344",
    riskType: "Yasaklı",
    description: "Personelimize fiziksel tacizde bulunmuştur. Kesin yasaklı müşteri.",
    staffNote: "Ali Yıldırım notu: Tüm personel bilgilendirildi. Bu müşteri kesinlikle kabul edilmeyecek. Polis kaydı da mevcut.",
    lastActionDate: "2026-03-15",
    createdBy: "Ali Yıldırım",
    status: "Aktif",
    createdAt: "2026-03-16",
    appointmentHistory: [
      "2026-03-15 - Fiziksel taciz şikayeti - Yasaklandı",
    ],
  },
  {
    id: "blk-005",
    customerId: "cus-016",
    customerName: "Leyla Bozkurt",
    phone: "+90 537 888 5566",
    riskType: "Dikkat",
    description: "Paket ödemesini yapmadı, borç biriktiriyor.",
    staffNote: "Seda Avcı: 3.000 TL borç var, defalarca arandı, ödeme sözü veriyor ama yapmıyor. Randevu vermeden önce ödeme istenmeli.",
    lastActionDate: "2026-05-05",
    createdBy: "Seda Avcı",
    status: "İzlemede",
    createdAt: "2026-04-10",
    appointmentHistory: [
      "2026-05-05 - Açık ödeme hatırlatma",
      "2026-04-20 - Ödeme sözü verdi ama yapmadı",
      "2026-04-10 - Açık ödeme oluştu",
    ],
  },
];